import { render, staticRenderFns } from "./LabelInsideProportionIcon.vue?vue&type=template&id=27899ac6&"
import script from "./LabelInsideProportionIcon.vue?vue&type=script&lang=js&"
export * from "./LabelInsideProportionIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports